import { Box, Skeleton as MuiSkeleton, styled } from "@mui/material";

const Root = styled(Box)(({ theme }) => ({
  padding: "40px 46px 40px 46px",

  [theme.breakpoints.down("md")]: {
    padding: "30px 20px",
  },
}));

const Skeleton = styled(MuiSkeleton)({
  borderRadius: 4,
});

export default function TableSkeleton() {
  return (
    <Root>
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        columnGap="8px"
        alignItems="center"
        mb={4}
      >
        <Skeleton variant="rectangular" width="20%" height={40} />
        <Skeleton variant="rectangular" width="20%" height={40} />
        <Skeleton variant="rectangular" width="20%" height={40} />
        <Skeleton variant="rectangular" width="20%" height={40} />
        <Skeleton variant="rectangular" width="20%" height={40} />
      </Box>
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={32} sx={{ mb: 2 }} />
    </Root>
  );
}
